import { find } from "lodash";
import { NOMENCLATURE } from "constants.js";

export function FormsService(
	api,
	$window,
	$userProfile, 
	appState
) {
	const service = this;

	service.getForms = getForms;
	service.refreshForms = refreshForms;

	function setNomenclature(forms) {
		forms.map(form => {
			form.nomenclature = {};

			for(const key in NOMENCLATURE) {
				const item = find(form.Nomenclature, { Code: NOMENCLATURE[key] });

				form.nomenclature[key] = (item || {}).Text;
			}

			form.Nomenclature = undefined;
		});
	}

	getForms.loading = null;

	function getForms() {
		const forms = angular.fromJson($window.sessionStorage.getItem("forms"));

		if(forms && forms.length) {
			appState.forms.items = forms;

			let form = find(forms, { selected: true });

			form = form || forms[0];

			return appState.forms.select(form);
		}

		getForms.loading = refreshForms().then(
			response => {
				getForms.loading = null;

				const thisUserProfile = $userProfile.getUserProfile();

				const form = find(response, { Id: thisUserProfile.formId }) || response[0];

				if(response.length >= 1) {
					return appState.forms.select(form);
				}

				return response;
			}
		);

		return getForms.loading;
	}

	function refreshForms() {
		return api.get("api/forms").then(forms => {
			appState.forms.items = forms;
			setNomenclature(forms);
			forms.forEach(form => { form.selected = form.Id === appState.forms.selected?.Id; });
			$window.sessionStorage.setItem("forms", angular.toJson(forms));
			return forms;
		});
	}

	return service;
}

export default angular
	.module("vesl.services.forms-service", [])
	.service("formsService", FormsService).name;
